import React, { useEffect, useState } from "react";
import { Layout, Alert, Form, Button, Space } from "antd";
import { connect } from "react-redux";
import { Redirect ,useHistory} from "react-router-dom";

/* CUSTOM COMPONENT */
import LoginHeader from "../../component/LoginHeader/LoginHeader";
import {
  SiteLayoutBackground,
  Left,
  Right,
  LoginBox,
  XContent,
  SignIn,
  TextBox,
  XButton,
  ForgotPassword,
  FormItem,
  SignUpDiv,
  SignUpLink,
  SocialButton,
} from "./LoginStyle";

/* Actions */
import { login } from "../../action/loginAction";
import { FaceBookIcon, GoogleIcon } from "../../component/CustomIcons";
import { BlankSpace } from "../../component/Xcomponent";

const { Footer } = Layout;

const Login = (props) => {
  /* variable & state */
  const history = useHistory();
  const { login, loginState } = props;

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [redirect, setRedirect] = useState(false);

  /* Callback */
  useEffect(() => {
    if (loginState.apiState === "success" && loginState.data !== null) {
      loginState.apiState = "";
      localStorage.setItem("LilacDoctorToken", loginState.data.token);
      localStorage.setItem("LilacDoctor", JSON.stringify(loginState.data?.user));
      localStorage.setItem(
        "LilacDoctorActivate",
        loginState.data.doctor.activate_status
      );
      localStorage.setItem("self_fee", loginState.data.doctor.self_fee);
      localStorage.setItem("couple_fee", loginState.data.doctor.couple_fee);
      localStorage.setItem("family_fee", loginState.data.doctor.family_fee);
      setRedirect(true);
      console.log("doctor data", loginState.data.doctor);
    } else {
      loginState.apiState = "";
    }
  }, [loginState.apiState]);

  /* function */
  const handleOnChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onFormSubmit = () => {
    login(formData);
  };

  return (
    <>
      {redirect && <Redirect to="/" />}
      <Layout style={{ backgroundColor: "#fff" }}>
        {/* <LoginHeader /> */}
        <XContent className="site-layout loginTopMargin">
          <SiteLayoutBackground>
            <Left>
              <div className="logoLogin">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/svg/Lilac-Insights-Logo1.svg"
                  }
                />
              </div>
              <LoginBox>
                <SignIn>Sign in</SignIn>
                {loginState.apiState === "success" && loginState.data == null && (
                  <Alert
                    style={{ marginBottom: 8 }}
                    message={loginState.message}
                    type="error"
                    showIcon
                  />
                )}

                <Form layout="vertical" onFinish={onFormSubmit}>
                  <FormItem
                    label="Email"
                    name="email"
                    rules={[
                      { required: true, message: "Please enter email id" },
                      { type: "email", message: "Email is not valid" },
                    ]}
                  >
                    <TextBox
                      name="email"
                      onChange={handleOnChange}
                      size="large"
                    />
                  </FormItem>
                  <FormItem
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: "Please enter password" }]}
                  >
                    <TextBox.Password
                      name="password"
                      onChange={handleOnChange}
                      size="large"
                    />
                  </FormItem>
                  <FormItem>
                    <ForgotPassword to={"/forgot-password"}>
                      Forgot Password?
                    </ForgotPassword>
                  </FormItem>
                  <FormItem>
                    <XButton
                      className="borderPrimary"
                      htmlType="submit"
                      type="primary"
                      size="large"
                      loading={loginState.apiState === "loading" ? true : false}
                    >
                      Sign In
                    </XButton>
                  </FormItem>
                  <FormItem>
                  <XButton
                      className="borderPrimary"
                      type="primary"
                      size="large"
                      onClick={()=>{
                        history.push("/sign-up")
                      }}
                    >
                      Sign Up
                    </XButton>
                  </FormItem>
                  <FormItem>
                    {/*<SignUpDiv>*/}
                    {/*    <label>*/}
                    {/*        Don't have an account?*/}
                    {/*        <SignUpLink to={"/sign-up"}>Sign Up</SignUpLink>*/}
                    {/*    </label>*/}
                    {/*</SignUpDiv>*/}
                  </FormItem>
                </Form>
                <BlankSpace />
                <BlankSpace />
                {/*<Space wrap>*/}
                {/*    <SocialButton shape="round" size="large"><GoogleIcon /> Sign up with Google</SocialButton>*/}
                {/*    <SocialButton shape="round" size="large"><FaceBookIcon /> Sign up with Facebook</SocialButton>*/}
                {/*</Space>*/}
              </LoginBox>
            </Left>
            <Right>
              <img
                height="100%"
                width="100%"
                src={process.env.PUBLIC_URL + "/images/svg/DoctorLogin.svg"}
                alt=""
              />
            </Right>
          </SiteLayoutBackground>
        </XContent>
        {/* <Footer style={{ textAlign: 'center', position: "fixed", bottom: 0, width: "100%", backgroundColor: "#15558d", color: "#fff" }}>Lilac Insights ©2021</Footer> */}
      </Layout>
    </>
  );
};

const mapStateToProps = (state) => ({
  loginState: state.login,
});

const mapDispatchToProps = (dispatch) => ({
  login: (params) => dispatch(login(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
